import { Log } from 'ng2-logger';
import queryString from 'querystring';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { LessonPage } from '../../components/lesson/main';
import Loading from '../../components/loading/loading';
import { IAction, IAppState } from '../../models/action/core';
import { TabMenuItems } from '../../models/components/lesson-menu-tab';
import { ICoursePage } from '../../models/pages/coursePage';
import * as Actions from '../../store/actions/coursePage';

import Translator from '../../core/i18n';

const T = Translator.create();
const _logger = Log.create('CourseMain');

let params;
let getActivityId: string | null;
let getClassId: any;
let getPageType: any;
let getActid: any;
let getWeekorunitId: any;

class CourseMain extends React.Component<ICoursePage> {
    constructor(props: any) {
        super(props);
        params = new URLSearchParams(props.location.search);
        getActivityId = params.get('activityId');
        getClassId = params.get('classId');
        getPageType = params.get('type');
        getActid = params.get('actid') ? params.get('actid') : null;
        getWeekorunitId = params.get('weekorunitid') ? params.get('weekorunitid') : null;
        if (getActivityId && getActivityId.trim() !== '') {
            this.props.dispatch(Actions.getCoursePageData(getActivityId, getClassId, getPageType, getActid, getWeekorunitId));
        }
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.location.search !== this.props.location.search) {
            let search: string = this.props.location.search;
            search = search.replace('?', '');
            const values = queryString.parse(search);
            const activityId = values.activityId.toString();
            const classId = values.classId.toString();

            const actId = values.actid ? values.actid.toString() : null;
            const weekOrUnitId = values.weekorunitid ? values.weekorunitid.toString() : null;
            const pageType = values.type ? values.type.toString() : TabMenuItems.courseContent.toString();

            if (activityId.toString().trim() !== '') {
                this.props.dispatch(Actions.getCoursePageData(activityId, classId, pageType, actId, weekOrUnitId));
                // window.location.reload();
            }
        }
    }

    componentDidMount () {
        this.props.dispatch(Actions.setShowAddActivity(true));
    }

    public render() {
        return (
            <>
                <Loading spinnerId={'CourseMain'} />
                <div>
                    {this.props.coursePageActivityId && this.props.coursePageActivityId.trim() !== '' ? (
                        <LessonPage />
                    ) : (
                        ''
                    )}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICoursePage): ICoursePage => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICoursePage = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        contextId: state.coursePage.actId,
        homePageSelectedTab: state.coursePage.homePageSelectedTab
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CCourseMain = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseMain);

export default withRouter(CCourseMain);
